'use strict';

var _ = require('lodash');
var DemandTransparencyForecastDataGridRegularTransformerFactory = function DemandTransparencyForecastDataGridRegularTransformerFactory(DataTransformer, momentService, demandTransparencyConstants) {
  function DemandTransparencyForecastDataGridRegularTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-forecast-profile-regular';
    this.targetType = 'demand-transparency-forecast-data';
    this.priority = 1;
  }
  DemandTransparencyForecastDataGridRegularTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyForecastDataGridRegularTransformerFactory.constructor = DemandTransparencyForecastDataGridRegularTransformerFactory;
  DemandTransparencyForecastDataGridRegularTransformerFactory.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyForecastDataGridRegularTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  DemandTransparencyForecastDataGridRegularTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DemandTransparencyForecastDataGridRegularTransformerFactory.prototype.transform = function (data) {
    var response = data.domain.results;
    var results = [];
    var utcSuffix = ':00.000+0000'; // date-time strings coming from the API are in UTC but don't contain the time zone suffix
    var field = momentService.FIELD.FORECAST_DATE;
    var format = field.format;
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    _.forEach(response, function (item) {
      var demands = item.demands;
      var length = demands && demands.length;
      for (var i = 0; i < length; i++) {
        var demand = demands[i];
        results.push({
          market: item.origin + '-' + item.destination,
          significantPOS: item.significantPOS,
          classGroup: item.classGroup,
          season: item.season,
          dayOfWeekGroup: item.dayOfWeekGroup,
          dtd: parseInt(demand.readingTimeInterval.substring(0, demand.readingTimeInterval.indexOf('d'))),
          remainingDemandESForecast: demand.remainingDemandESForecast,
          remainingDemandESVariance: demand.remainingDemandESVariance,
          untruncatedDemandESForecast: demand.untruncatedDemandESForecast,
          untruncatedDemandESVariance: demand.untruncatedDemandESVariance,
          remainingDemandKFForecast: demand.remainingDemandKFForecast,
          remainingDemandKFVariance: demand.remainingDemandKFVariance,
          untruncatedDemandKFForecast: demand.untruncatedDemandKFForecast,
          untruncatedDemandKFVariance: demand.untruncatedDemandKFVariance,
          blendedRemainingDemandForecast: demand.blendedRemainingDemandForecast,
          blendedRemainingDemandForecastError: demand.blendedRemainingDemandForecastError,
          remainingDemandESNumberOfObservations: demand.remainingDemandESNumberOfObservations,
          remainingDemandESFirstForecastDate: demand.remainingDemandESFirstForecastDate && memoizedMomentOfDate(demand.remainingDemandESFirstForecastDate + utcSuffix, field, format),
          remainingDemandESLastForecastDate: demand.remainingDemandESLastForecastDate && memoizedMomentOfDate(demand.remainingDemandESLastForecastDate + utcSuffix, field, format),
          sponsor: item.sponsor,
          profileLevel: demandTransparencyConstants.PROFILE_LEVEL_MAPPING[item.profileLevel]
        });
      }
    });
    return results;
  };
  function getMomentOfDate(date, field, format) {
    return momentService.of(date, field, format);
  }
  return DemandTransparencyForecastDataGridRegularTransformerFactory;
};
DemandTransparencyForecastDataGridRegularTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'DemandTransparencyConstants'];
module.exports = DemandTransparencyForecastDataGridRegularTransformerFactory;